import type { InsightChatStep } from '@wundo/shared/insightChat.ts';

/** A step in one line, the way a colleague would say what they just did. */
export function stepLabel(step: InsightChatStep): string {
  const { args } = step;

  switch (step.tool) {
    case 'run_sql':
      return `Query · ${typeof args.sql === 'string' ? args.sql.replace(/\s+/g, ' ').trim() : ''}`;
    case 'read_design_doc':
      return `Read design doc · ${typeof args.path === 'string' ? args.path : ''}`;
    case 'spawn_subagents': {
      const count = Array.isArray(args.tasks) ? args.tasks.length : 0;
      return `Sent ${count} helper${count === 1 ? '' : 's'}`;
    }
    case 'update_memory':
      return "Updated the routine's notes";
    default:
      return step.tool;
  }
}
